/**
 * 前端按钮权限映射表
 * 权限编码为I_000000表示默认有此权限
 */
const map = [
    //实时告警
    {
        '/realTimeAlarm:query': '03020101', //查询
        '/realTimeAlarm:update': '03020102', //修改
        '/realTimeAlarm:add': '03020102', //新增
    },
    //告警记录
    {
        '/historyAlarm:query': '03020201', //告警记录查询
        '/historyAlarm:export': '03020202', //导出
    },
    //任务管理
    {
        '/taskCenter/list:query': '03020301', //查询
        '/taskCenter/list:add': '03020302', //新增
        '/taskCenter/list:update': '03020303' //修改
    },
    //视频巡逻-巡逻计划
    {
        '/videoPatrol/plan:query': '03030101',
        '/videoPatrol/plan:add': '03030102',
        '/videoPatrol/plan:update': '03030103',
        '/videoPatrol/plan:delete': '03030104',
    },
    //视频巡逻-实时巡逻
    {
        '/videoPatrol/task:query': '03030201', //查询
        '/videoPatrol/task:update': '03030202', //执行
    },
    //视频巡逻-巡逻历史
    {
        '/videoPatrol/history:query': '03030301', //查询
        '/videoPatrol/history:export': '03030302', //导出
    },
    //电子巡更-巡更计划
    {
        '/elePatrol-patrolplan:query': '03040101', //查询
        '/elePatrol-patrolplan:add': '03040102', //新增
        '/elePatrol-patrolplan:update': '03040103', //   修改
        '/elePatrol-patrolplan:delete': '03040104', //  删除
    },
    //电子巡更-巡更记录
    {
        '/elePatrol-patrolrecord:query': '03040201', //查询
        '/elePatrol-patrolrecord:export': '03040202'
    },

    //布控管理
    // 人脸注册
    {
        '/personMg:query': '03050101', // 查询人脸库
        '/personMg:add': '03050102', // 新增人脸库
        '/personMg:update': '03050103', // 修改人脸库
        '/personMg:delete': '03050103', // 删除人脸库
        '/personMg:queryList': '03050104', // 查询人脸名单
        '/personMg:addList': '03050105', // 新增人脸名单
        '/personMg:updateList': '03050106', // 修改人脸名单
        '/personMg:deleteList': '03050107', // 删除人脸名单
    },
    //车牌注册
    {
        '/carPatrolBlack:queryGroup': '03060101', // 查询车辆名单组
        '/carPatrolBlack:addGroup': '03060102', // 新增车辆名单组
        '/carPatrolBlack:updateGroup': '03060103', // 修改车辆名单组
        '/carPatrolBlack:deleteGroup': '03060104', // 删除车辆名单组
        '/carPatrolBlack:query': '03060105', // 查询车辆名单
        '/carPatrolBlack:add': '03060106', // 新增车辆名单
        '/carPatrolBlack:update': '03060107', // 修改车辆名单
        '/carPatrolBlack:delete': '03060108', // 删除车辆名单
    },

    //信息布控
    {
        '/controlManage/task:query': '03050201', //查询
        '/controlManage/task:add': '03050202',
        '/controlManage/task:delete': '03050203',
        '/controlManage/task:update': '03050204', //修改
    },
    //布控记录
    {
        '/controlManage/record:query': '03050401' //查询
    },
    //人员研判
    {
        '/personResearch:query': '03050301' //查询
    },
    // 车辆研判
    {
        '/carResearch:query': '03060301' //查询
    },

    //超速配置
    {
        '/carspeed/speedConfig:query': '03080101', //查询
        '/carspeed/speedConfig:add': '03080102',
        '/carspeed/speedConfig:update': '03080103',
        '/carspeed/speedConfig:delete': '03080104',
    },
    //超速记录
    {
        '/carspeed/speedRecord:query': '03080201', //查询
        '/carspeed/speedRecord:export': '03080202', //导出
    },
    //识别中心
    {
        '/access/identifyCenter:query': '03090101', //查询
        '/access/identifyCenter:mark': '03090102' //标记
    },
    //识别记录
    {
        '/access/identifyRecord:query': '03090201' //查询
    },
    //标记记录
    {
        '/access/markingRecord:query': '03090301'
    },
    //自定义工单
    {
        '/workorder/index:query': '03100101', // 查询
        '/workorder/index:add': '03100102', // 新增
        '/workorder/index:delete': '03100104', // 删除
        '/workorder/index:update': '03100103', // 修改
    },
    //罚单管理
    {
        '/violation/list:query': '03110101', //查询
        '/violation/list:update': '03110102',
    },
    //广播管理-音频管理
    {
        '/broadcast/audio:query': '03120101', //查询
        '/broadcast/audio:add': '03120102',
        '/broadcast/audio:sync': '03120103', //同步
        '/broadcast/audio:delete': '03120104',

    },
    // 远程喊话
    {
        '/broadcast/call:query': '03120201'
    },
    //联动播放广播
    {
        '/broadcast/linkage:query': '03120301',
        '/broadcast/linkage:add': '03120302',
        '/broadcast/linkage:update': '03120303',
        '/broadcast/linkage:delete': '03120304',
    },

    // *****通行管理
    // -------人员管理
    // 人员信息
    {
        '/peopleInfo:query': '04010101', //查询
        '/peopleInfo:sync': '04010102', //同步
        '/peopleInfo:update': '04010103', //修改
    },
    // 人员通行权限
    {
        '/personAuthorization/index:query': '04020201',
        '/personAuthorization/index:update': '04020202',
        '/personAuthorization/index:sync': '04020203',
        '/personAuthorization/index:delete': '04020204',
    },
    // 人员通行记录
    {
        '/personAccessRecord/index:query': '04040201',
    },
    // 车间通行记录
    {
        '/workshopAproval:query': '04010401',
    },
    // -------车辆管理
    // 车辆信息
    {
        '/carInfo/index:query': '04010201',
        '/carInfo/index:add': '04010202',
        '/carInfo/index:import': '04010203',
        '/carInfo/index:delete': '04010204',
        '/carInfo/index:update': '04010205',
    },
    // 车辆通行权限
    {
        '/carAuthorization/index:query': '04020301',
        '/carAuthorization/index:add': '04020302',
        '/carAuthorization/index:sync': '04020303',
        '/carAuthorization/index:delete': '04020304',
    },
    // 车辆通行记录
    {
        '/carAccessRecord/index:query': '04040301',
    },
    // 车辆审批记录
    {
        '/carAccessRecord/index:query': '04020401',
    },
    // 车辆授权记录
    {
        '/carAuthorizationRecord/index:query': '04020501',
    },
    // -------出入口管理
    // 出入口管理

    // 出入口控制记录
    {
        '/security/getwayRecord:query': '04030301',
    },
    // -------访客预约
    // 预约记录
    {
        '/access/visitorRecord:query': '04040101',
        '/access/visitorRecord:export': '04040102',
    },
    // 申请配置
    {
        '/visitorConfig:query': '04040201',
        '/visitorConfig:config': '04040202',
    },
    // -------授权同步
    // 授权同步
    {
        '/authorizationSync/index:query': '04050101',
        '/authorizationSync/index:reload': '04050102'
    },

    //消防管理-资产管理
    {
        '/assets/assetsManage:query': '05010101', //查询
        '/assets/assetsManage:add': '05010102',
        '/assets/assetsManage:update': '05010103',
        '/assets/assetsManage:delete': '05010104',
    },
    //资产归领管理
    {
        '/assets/assetsRecipient:query': '05010201', //查询
        '/assets/assetsRecipient:add': '05010202', //新增
        '/assets/assetsRecipient:returned': '05010203' //归还
    },
    //资产巡检
    {
        '/assetinspection/inspectionPlan:query': '05010301', //查询
        '/assetinspection/inspectionPlan:add': '05010302',
        '/assetinspection/inspectionPlan:delete': '05010303',
        '/assetinspection/inspectionPlan:active': '05010304', //启用\禁用
    },
    //巡检项配置
    {
        '/assetinspection/assetsConfig:query': '05010401',
        '/assetinspection/assetsConfig:add': '05010402',
        '/assetinspection/assetsConfig:delete': '05010403',

    },
    //巡检记录
    {
        '/assetinspection/inspectionRecord:query': '05010501'
    },
    //消防巡查管理-巡检点管理
    {
        '/assetsManage/assetsManage:query': '05020101',
        '/assetsManage/assetsManage:add': '05020102',
        '/assetsManage/assetsManage:update': '05020103',
        '/assetsManage/assetsManage:delete': '05020104',
        '/assetsManage/assetsManage:import': '05020105', //导入
        '/assetsManage/assetsManage:export': '05020106', //导出

    },
    //巡检计划
    {
        '/assetsManage/plan:query': '05020201',
        '/assetsManage/plan:add': '05020202',
        '/assetsManage/plan:update': '05020203',
        '/assetsManage/plan:delete': '05020204',
    },
    //巡检记录
    {
        '/assetsManage/record:query': '05020301',
        '/assetsManage/record:export': '05020302', //导出
    },
    //巡检项
    {
        '/assetsManage/itemConfig:query': '05020401',
        '/assetsManage/itemConfig:add': '05020402',
        '/assetsManage/itemConfig:delete': '05020403',
        '/assetsManage/itemConfig:update': '05020404',
    },
    //消防管理-消防告警
    {
        '/fireAlarm:pushAlarm': '050501', // 消防告警
        '/fireAlarm:query': '05050101', //
        '/fireAlarm:update': '05050102',
    },
    //消防控制
    {
        // '/fireControl:control': '05050202', //控制
        '/fireControl:control': '05070202', //控制
    },
    //控制记录
    {
        '/fireControlRecord:query': '05050301',
        '/fireControlRecord:export': '05070302', //导出
    },
    //消防告警记录
    {
        '/fireHistory:query': '05050401',
        '/fireHistory:export': '05050402', //导出
    },
    // *****预案管理
    // -------预案管理
    // 预案配置
    {
        '/reserve/reserveplan:query': '06010101',
        '/reserve/reserveplan:add': '06010102',
        '/reserve/reserveplan:update': '06010103',
        '/reserve/reserveplan:delete': '06010104',
    },
    // 预案执行
    {
        '/reserveImplement:add': '06010202',
        '/reserveImplement:update': '06010203',
    },
    // 预案记录
    {
        '/reserve/reserveRecord:query': '06010301',
    },
    //联动管理
    {
        '/linkage/Ruleset:query': '06020101',
        '/linkage/Ruleset:add': '06020102',
        '/linkage/Ruleset:modify': '06020103', //修改
        '/linkage/Ruleset:delete': '06020104',
        '/linkage/Ruleset:active': '06020105',
    },
    // -------应急管理
    // 应急卡
    {
        '/workshop/emergency-handle-card:query': '06030101',
        '/workshop/emergency-handle-card:add': '06030102',
        '/workshop/emergency-handle-card:update': '06030103',
        '/workshop/emergency-handle-card:delete': '06030104',
    },
    // 应急处理流程
    {
        '/workshop/emergency-handle:query': '06030201',
        '/workshop/emergency-handle:add': '06030202',
        '/workshop/emergency-handle:update': '06030203',
        '/workshop/emergency-handle:delete': '06030204',
    },
    // 应急组
    {
        '/workshop/emergency-group:query': '06030301',
        '/workshop/emergency-group:add': '06030302',
        '/workshop/emergency-group:update': '06030303',
        '/workshop/emergency-group:delete': '06030304',
    },
    // *****设施管理
    // -------设备管理
    // 设备接入
    {
        '/deviceaccess/index:query': '98010101',
        '/deviceaccess/index:addDevice': '98010102',
        '/deviceaccess/index:updateDevice': '98010103',
        '/deviceaccess/index:deleteDevice': '98010104',
        '/deviceaccess/index:syncDevice': '98010105',
        '/deviceaccess/index:importDevice': '98010106',
        '/deviceaccess/index:exportDevice': '98010107',
    },
    // 设施维护
    {
        '/cameralist/devicelist:query': '98010201',
        '/cameralist/devicelist:export': '98010202',
        '/cameralist/devicelist:update': '98010203',
        '/cameralist/devicelist:move': '98010204',
    },
    // 事件配置
    {
        '/deviceaccess/eventconfignew:query': '03020401',
        '/deviceaccess/eventconfignew:add': '03020402',
        '/deviceaccess/eventconfignew:update': '03020403',
        '/deviceaccess/eventconfignew:delete': '03020404',
    },
    //  告警抑制
    {
        '/deviceaccess/alarmInhibition:query': '98010401',
        '/deviceaccess/alarmInhibition:import': '98010402',
        '/deviceaccess/alarmInhibition:update': '98010403',
        '/deviceaccess/alarmInhibition:delete': '98010404',
    },
    //系统管理-账户管理
    {
        '/account/index:query': '990101',
        '/account/index:add': '990102',
        '/account/index:update': '990103',
        '/account/index:delete': '990104',
        '/account/index:resetPassword': '990105', //重置密码
        '/account/index:setPermission': '990106', //权限设置
        '/account/index:active': '990107', //启用/禁用
    },
    //角色管理
    {
        '/accountgroup:query': '990201',
        '/accountgroup:add': '990202',
        '/accountgroup:update': '990203',
        '/accountgroup:delete': '990204',
        '/accountgroup:addAccount': '990205', //关联账户
    },
    //关联账户-区域管理
    {
        '/area:query': '99030101',
        '/area:add': '99030102',
        '/area:update': '99030103',
        '/area:delete': '99030104',
    },
    //楼栋管理
    {
        '/building/index:query': '99030201',
        '/building/index:add': '99030202',
        '/building/index:update': '99030203',
        '/building/index:delete': '99030204',
    },
    //车间管理
    {
        '/workShopManage:query': '99030301',
        '/workShopManage:add': '99030302',
        '/workShopManage:update': '99030303',
        '/workShopManage:delete': '99030304',
    },
    //工作组管理
    {
        '/workGroup/index:query': '99040101',
        '/workGroup/index:add': '99040102',
        '/workGroup/index:update': '99040103',
        '/workGroup/index:delete': '99040104',
    },
    //保卫换岗记录
    {
        '/securityShift:query': '99040201'
    },
    //日志管理
    {
        '/log:query': '99050101',
    },
    //数据库备份
    {
        '/databaseBackup:query': '99050201',
        '/databaseBackup:add': '99050202',
        '/databaseBackup:delete': '99050203',
    },
    //系统参数设置
    {
        '/system:query': '99060101',
        '/system:update': '99060102',
    },
    //权限组管理
    {
        '/authGroup/index:query': '990701',
        '/authGroup/index:add': '990702',
        '/authGroup/index:update': '990703',
        '/authGroup/index:delete': '990704',
    },
    //消防事件工单
    {
        'task:query': '05050501',
        'task:add': '05050502',
        'task:update': '05050503',
    }, {
        '/fireTaskCenter/list:query': '05050501',
        '/fireTaskCenter/list:add': '05050502',
        '/fireTaskCenter/list:update': '05050503',
    }
]
export default map
